import state from '@/store/modules/bs_app/state'
import actions from '@/store/modules/bs_app/actions'
import mutations from '@/store/modules/bs_app/mutations'
import getters from '@/store/modules/bs_app/getters'

export default {
  state,
  actions,
  mutations: {
    ...mutations,
    ...{
      savePointCheckedBox(state, data) {
        console.log('vaule checkedk store', data)
        console.log('state', state)
        if (state.bs_app.bs_app_02_008) {
          state.bs_app.bs_app_02_008.checkedValue = data
        } else {
          state.bs_app.bs_app_02_008 = {
            checkedValue: data
          }
        }
      }
    }
  },
  getters
}
